<template>
  <div>
    <div :class="alertClasses">
      <div :class="getSnackbarTextClass">
        {{ message }}
      </div>
      <div v-if="hasAction" class="ui-snackbar-action">
        <router-link v-if="action.type === 'link'" :to="action.to">
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: null,
    },
    showButton: Boolean,
    duration: {
      type: [String, Number],
      default: 3000,
    },
  },
  computed: {
    hasAction() {
      return Boolean(this.action && (this.action.type || this.action.message));
    },
    getAlertClass() {
      if (this.action?.success === true) {
        return 'success-alert';
      }
      if (this.action?.success === false) {
        return 'alert-error';
      }
      if (this.action?.success === 'warning') {
        return 'alert-warning';
      }
      return 'ui-snackbar';
    },
    alertClasses() {
      return [
        this.getAlertClass,
        {
          'ui-snackbar--with-action': this.hasAction,
          'ui-snackbar--centered': !this.hasAction,
        },
      ];
    },
    getSnackbarTextClass() {
      if (this.action?.success === true || this.action?.success === false) {
        return 'ui-snackbar-text';
      }
      if (this.action?.success === 'warning') {
        return 'ui-snackbar-warning-text';
      }
      return 'ui-snackbar-white';
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
};
</script>
